import { cn } from '../../lib/cn';
import { LOGO_PATHS as P } from './logo-paths';

export interface LogoProps {
  /** `horizontal` für Kopfzeilen und Login, `wordmark` in der Sidebar und unter 40 px, `mark` erst ab 48 px. */
  variant?: 'horizontal' | 'wordmark' | 'mark';
  height?: number;
  title?: string;
  className?: string;
}

const VIEWBOX = { horizontal: [1636.5, 512], wordmark: [300.4, 73], mark: [512, 512] } as const;

/** Das Logo als Inline-SVG; Navy folgt logo-ink (dunkel: Weiß), Cyan folgt logo-accent. */
export function Logo({ variant = 'horizontal', height = 32, title = 'Elbklar', className }: LogoProps) {
  const [w, h] = VIEWBOX[variant];
  return (
    <svg
      role="img"
      aria-label={title}
      width={Math.round((w / h) * height)}
      height={height}
      viewBox={`0 0 ${w} ${h}`}
      className={cn('block shrink-0', className)}
    >
      {variant === 'wordmark' ? (
        <>
          <path d={P.wordInk} className="fill-logo-ink" />
          <path d={P.wordAccent} className="fill-logo-accent" />
        </>
      ) : (
        <>
          <path d={P.markAccent} className="fill-logo-accent" fillRule="evenodd" />
          <path d={P.markInk} className="fill-logo-ink" fillRule="evenodd" />
          {variant === 'horizontal' && (
            <>
              <path d={P.lockWordInk} className="fill-logo-ink" />
              <path d={P.lockWordAccent} className="fill-logo-accent" />
            </>
          )}
        </>
      )}
    </svg>
  );
}
